import { IStoreReady } from '@/store/lib/storeSupport';
import { getModule, Module, Mutation, MutationAction, VuexModule } from 'vuex-module-decorators';
import store from '@/store'
import { DataEntityStock, ProductsStock } from "@/entity/warehouse/Products/ProductsStock.types"
import { PaginationRequestType } from "@/entity/common/pagination.types"
import { prepareFormData } from '@/store/utils/formDataHelper'

@Module({
    namespaced: true,
    name: 'productsStock',
    store,
    dynamic: true,
})
class ProductsStockModule extends VuexModule implements IStoreReady {
    items: ProductsStock | null = null;
    item: DataEntityStock | null = null;
    itemsLoaded = false;
    itemLoaded = false;
    ready = false;

    @MutationAction
    async fetchAll( data?: PaginationRequestType ): Promise< { items: ProductsStock; itemsLoaded: boolean} >{
        let itemsLoaded = false
        const items = await store.$repository.productsStock.fetchAll(prepareFormData(data))
        if (items) {
            itemsLoaded = true
        }
        return { items, itemsLoaded}
    }

    @MutationAction
    async fetchData(data: PaginationRequestType): Promise<{ item: DataEntityStock; itemLoaded:boolean }> {
        let itemLoaded = false
        const item = await store.$repository.productsStock.fetchData(data)
        if (item) {
            itemLoaded = true
        }
        return {item, itemLoaded}
    }

    @Mutation
    setReady(st:boolean){
        this.ready = st
    }
}
export const ProductsStockStore = getModule(ProductsStockModule)